var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 37.5C59 49.3741 49.3741 59 37.5 59C25.6259 59 16 49.3741 16 37.5C16 25.6259 25.6259 16 37.5 16C49.3741 16 59 25.6259 59 37.5Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6351 34.5946C45.6351 41.334 40.1718 46.7973 33.4324 46.7973C26.6931 46.7973 21.2297 41.334 21.2297 34.5946C21.2297 27.8552 26.6931 22.3919 33.4324 22.3919C40.1718 22.3919 45.6351 27.8552 45.6351 34.5946Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.f7a02eaa631bdcc2695559a88aed1601.svg";
export { ForwardRef as ReactComponent };